import { ArrowBackIos, ArrowLeft } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  Modal,
} from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import * as Images from '../../assets';
import {
  LightBlueButton,
  LightGrayButton,
  SwitchWrapper,
  TextButtonLight,
} from '../../components';
import { routesName } from '../../constants/routes-name';
import { Link } from 'react-router-dom';

const CookiesPopup = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState('');
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [choices, setChoices] = useState({
    necessary: false,
    functionality: false,
    experience: false,
    measurement: false,
    marketing: false,
  });

  useEffect(() => {
    const tempChoices = localStorage.getItem('choices');
    if (tempChoices) {
      setChoices(JSON.parse(tempChoices));
    }
  }, []);

  const acceptRejectAll = (value) => {
    setChoices({
      necessary: value,
      functionality: value,
      experience: value,
      measurement: value,
      marketing: value,
    });
  };

  const saveChoices = () => {
    localStorage.setItem('choices', JSON.stringify(choices));
  };

  return (
    <div>
      <IconButton
        onClick={handleOpen}
        style={{
          position: 'absolute',
          height: '35px',
          width: '35px',
          bottom: '10px',
          left: '10px',
          backgroundColor: '#fff',
          borderRadius: '6px',
          border: '1px solid #00000013',
          padding: '0px',
          boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
        }}
      >
        <img src={Images.one} />
      </IconButton>

      <Modal
        open={open}
        //onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { lg: 800, md: 600, sm: 450, xs: 320 },
            bgcolor: 'background.paper',
            boxShadow: 24,
          }}
          className="rounded-md"
          key={show}
        >
          {!show && (
            <Fragment>
              <div className="bg-[var(--blue)] px-7 py-7 flex flex-wrap justify-between items-center">
                <img src={Images.AppLogo} alt="logo" width={150} />

                <span
                  className="text-[var(--dark-blue)] hover:text-[var(--blue)] cursor-pointer hover:bg-[var(--dark-blue)] text-sm rounded-full"
                  onClick={() => setShow('full-cookies')}
                >
                  See full Cookie Policy
                </span>
              </div>
              <hr style={{ border: 'o.5px solid #00000013' }} />

              <div className="relative min-h-[270px] max-h-[450px] overflow-y-auto">
                <div className="px-8 py-6 space-y-1 bg-[var(--blue)]">
                  <div className="font-semibold text-xl uppercase">
                    Your Privacy Choices
                  </div>
                  <div className="text-sm leading-[1.5]">
                    In this panel you can express some preferences related to
                    the processing of your personal information.
                    <br />
                    You may review and change expressed choices at any time by
                    resurfacing this panel via the provided link.
                    <br />
                    To deny your consent to the specific processing activities
                    described below, switch the toggles to off or use the
                    “Reject all” button and confirm you want to save your
                    choices.
                  </div>
                </div>
                <div className="sticky top-0 flex flex-wrap justify-end gap-4 px-7 py-7 border-b-[#00000013] border-b-2 bg-white">
                  <LightGrayButton onClick={() => acceptRejectAll(false)}>
                    Reject All
                  </LightGrayButton>
                  <LightGrayButton onClick={() => acceptRejectAll(true)}>
                    Accept All
                  </LightGrayButton>
                </div>

                <div className="px-7 py-7 space-y-4 h-full overflow-y-auto">
                  <div className="space-y-1 py-2">
                    <div className="text-lg uppercase font-semibold">
                      Your consent preferences for tracking technologies
                    </div>
                    <div className="text-sm tracking-[0.2px]">
                      The options provided in this section allow you to
                      customise your consent preferences for any tracking
                      technology used for the purposes described below. To learn
                      more about how these trackers help us and how they work,
                      refer to the cookie policy. Please be aware that denying
                      consent for a particular purpose may make related features
                      unavailable.
                    </div>
                  </div>

                  <hr className="border-b-[#00000013]" />

                  <div className="space-y-3 py-2">
                    <div className="text-[0.9em] leading-[1.8] uppercase font-semibold flex flex-wrap items-center justify-between">
                      <div>Necessary</div>
                      <SwitchWrapper
                        checked={choices.necessary}
                        onChange={(event) =>
                          setChoices((old) => ({
                            ...old,
                            necessary: event.target.checked,
                          }))
                        }
                      />
                    </div>
                    <div className="text-sm tracking-[0.2px]">
                      These trackers are used for activities that are strictly
                      necessary to operate or deliver the service you requested
                      from us and, therefore, do not require you to consent.
                    </div>
                  </div>

                  <hr className="border-b-[#00000013]" />

                  <div className="space-y-3 py-2">
                    <div className="text-[0.9em] leading-[1.8] uppercase font-semibold flex flex-wrap items-center justify-between">
                      <div>Functionality</div>
                      <SwitchWrapper
                        checked={choices.functionality}
                        onChange={(event) =>
                          setChoices((old) => ({
                            ...old,
                            functionality: event.target.checked,
                          }))
                        }
                      />
                    </div>
                    <div className="text-sm tracking-[0.2px]">
                      These trackers enable basic interactions and
                      functionalities that allow you to access selected features
                      of our service and facilitate your communication with us.
                    </div>
                  </div>

                  <hr className="border-b-[#00000013]" />

                  <div className="space-y-3 py-2">
                    <div className="text-[0.9em] leading-[1.8] uppercase font-semibold flex flex-wrap items-center justify-between">
                      <div>Experience</div>
                      <SwitchWrapper
                        checked={choices.experience}
                        onChange={(event) =>
                          setChoices((old) => ({
                            ...old,
                            experience: event.target.checked,
                          }))
                        }
                      />
                    </div>
                    <div className="text-sm tracking-[0.2px]">
                      These trackers help us to improve the quality of your user
                      experience and enable interactions with external content,
                      networks and platforms.
                    </div>
                  </div>

                  <hr className="border-b-[#00000013]" />

                  <div className="space-y-3 py-2">
                    <div className="text-[0.9em] leading-[1.8] uppercase font-semibold flex flex-wrap items-center justify-between">
                      <div>Measurement</div>
                      <SwitchWrapper
                        checked={choices.measurement}
                        onChange={(event) =>
                          setChoices((old) => ({
                            ...old,
                            measurement: event.target.checked,
                          }))
                        }
                      />
                    </div>
                    <div className="text-sm tracking-[0.2px]">
                      These trackers help us to measure traffic and analyse your
                      behaviour to improve our service.
                    </div>
                  </div>

                  <hr className="border-b-[#00000013]" />

                  <div className="space-y-3 py-2">
                    <div className="text-[0.9em] leading-[1.8] uppercase font-semibold flex flex-wrap items-center justify-between">
                      <div>Marketing</div>
                      <SwitchWrapper
                        checked={choices.marketing}
                        onChange={(event) =>
                          setChoices((old) => ({
                            ...old,
                            marketing: event.target.checked,
                          }))
                        }
                      />
                    </div>
                    <div className="text-sm tracking-[0.2px]">
                      These trackers help us to deliver personalised ads or
                      marketing content to you, and to measure their
                      performance.
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-between gap-4 items-center px-7 py-7 bg-[#fafafa] border-t-gray-200">
                <LightGrayButton
                  sx={{ border: '1px solid #00000013' }}
                  onClick={handleClose}
                >
                  <ArrowBackIos fontSize="small" /> Back
                </LightGrayButton>
                <LightBlueButton
                  size="small"
                  onClick={() => {
                    saveChoices();
                    handleClose();
                  }}
                >
                  Save And Continue
                </LightBlueButton>
              </div>
            </Fragment>
          )}

          {show === 'full-cookies' && (
            <Fragment>
              <div className="bg-[var(--blue)] border-b-2 px-6 py-6 flex flex-wrap justify-between items-center">
                <TextButtonLight
                  sx={{
                    color: 'var(--dark-blue)',
                    border: '1px solid',
                    px: 2,
                    letterSpacing: '0px',
                    textTransform: 'none',
                    '&:hover': {
                      backgroundColor: 'var(--dark-blue)',
                      color: 'var(--blue)',
                    },
                  }}
                  onClick={() => setShow('')}
                >
                  <div className="flex items-center text-[15px]">
                    <ArrowBackIos fontSize="small" /> Back
                  </div>
                </TextButtonLight>
              </div>

              <div className="relative min-h-[270px] max-h-[560px] overflow-y-auto">
                <CookiesPlolicy onClose={handleClose} />
                <div className="flex justify-end">
                  <span
                    className="text-[var(--dark-blue)] hover:text-[var(--blue)] cursor-pointer hover:bg-[var(--dark-blue)] text-sm rounded-full"
                    onClick={() => {
                      setShow('complete-privacy');
                    }}
                  >
                    Show the complete Privacy Policy
                  </span>
                </div>
              </div>
            </Fragment>
          )}

          {show === 'complete-privacy' && (
            <Fragment>
              <div className="bg-[var(--blue)] border-b-2 px-6 py-6 flex flex-wrap justify-between items-center">
                <TextButtonLight
                  sx={{
                    color: 'var(--dark-blue)',
                    border: '1px solid',
                    px: 2,
                    letterSpacing: '0px',
                    textTransform: 'none',
                    '&:hover': {
                      backgroundColor: 'var(--dark-blue)',
                      color: 'var(--blue)',
                    },
                  }}
                  onClick={() => setShow('')}
                >
                  <div className="flex items-center text-[15px]">
                    <ArrowBackIos fontSize="small" /> Back
                  </div>
                </TextButtonLight>
              </div>
              <div className="relative min-h-[270px] max-h-[560px] overflow-y-auto">
                <PrivacyPolicy onClose={handleClose} />

                <div className="flex justify-end">
                  <span
                    className="text-[var(--dark-blue)] hover:text-[var(--blue)] cursor-pointer hover:bg-[var(--dark-blue)] text-sm rounded-full"
                    onClick={() => {
                      setShow('full-cookies');
                    }}
                  >
                    Show the simplified Privacy Policy
                  </span>
                </div>
              </div>
            </Fragment>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default CookiesPopup;

export const CookiesPlolicy = ({ onClose = () => {} }) => {
  return (
    <div className="">
      <div className="px-8 py-5 space-y-4">
        <div className="space-y-5 py-2">
          <div className="text-lg font-semibold">
            Cookie Policy of aid-link.com
          </div>
          <div className="text-[0.9em] leading-[1.8]">
            This document informs Users about the technologies that help this
            Application to achieve the purposes described below. Such
            technologies allow the Owner to access and store information (for
            example by using a Cookie) or use resources (for example by running
            a script) on a User’s device as they interact with this Application.
          </div>
          <div className="text-[0.9em] leading-[1.8]">
            For simplicity, all such technologies are defined as "Trackers"
            within this document – unless there is a reason to differentiate.
            <br /> For example, while Cookies can be used on both web and mobile
            browsers, it would be inaccurate to talk about Cookies in the
            context of mobile apps as they are a browser-based Tracker. For this
            reason, within this document, the term Cookies is only used where it
            is specifically meant to indicate that particular type of Tracker.
          </div>
          <div className="text-[0.9em] leading-[1.8]">
            Some of the purposes for which Trackers are used may also require
            the User's consent. Whenever consent is given, it can be freely
            withdrawn at any time following the instructions provided in this
            document.
          </div>
          <div className="text-[0.9em] leading-[1.8]">
            This Application uses Trackers managed directly by the Owner
            (so-called “first-party” Trackers) and Trackers that enable services
            provided by a third-party (so-called “third-party” Trackers). Unless
            otherwise specified within this document, third-party providers may
            access the Trackers managed by them.
            <br />
            The validity and expiration periods of Cookies and other similar
            Trackers may vary depending on the lifetime set by the Owner or the
            relevant provider. Some of them expire upon termination of the
            User’s browsing session. In addition to what’s specified in the
            descriptions within each of the categories below, Users may find
            more precise and updated information regarding lifetime
            specification as well as any other relevant information – such as
            the presence of other Trackers - in the linked privacy policies of
            the respective third-party providers or by contacting the Owner.
          </div>
        </div>

        <div className="text-lg font-semibold py-5">
          How this Application uses Trackers
        </div>

        <div className="space-y-4 py-3 ">
          <div className="space-y-3 py-1 ">
            <div className="text-lg font-semibold">Necessary</div>
            <div className="text-[0.9em] leading-[1.8]">
              This Application uses so-called “technical” Cookies and other
              similar Trackers to carry out activities that are strictly
              necessary for the operation or delivery of the Service.
            </div>
          </div>

          <div className="space-y-3 py-2">
            <div className="space-y-3">
              <div className="text-lg font-semibold ">Experience</div>

              <div className="text-[0.9em] leading-[1.8]">
                This Application uses Trackers to improve the quality of the
                user experience and enable interactions with external content,
                networks and platforms.
              </div>
              <div className="text-[0.9em] leading-[1.8] font-semibold">
                Trackers managed by third parties
              </div>
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <Accordion disableGutters>
                    <AccordionSummary
                      expandIcon={<ArrowLeft />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="font-semibold text-[0.9em] leading-[1.8]"
                    >
                      <img
                        src={Images.file}
                        className="h-[24px] w-[24px] mr-3"
                      />
                      Google Maps widget (Google Ireland Limited)
                    </AccordionSummary>
                    <AccordionDetails className="text-[0.9em] leading-[1.8] space-y-2">
                      <div>
                        Google Maps is a maps visualisation service provided by
                        Google Ireland Limited that allows this Application to
                        incorporate content of this kind on its pages.
                      </div>
                      <div>
                        Personal Data processed: Trackers and Usage Data.
                      </div>
                      <div>Place of processing: Ireland – Privacy Policy.</div>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Accordion disableGutters>
                    <AccordionSummary
                      expandIcon={<ArrowLeft />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="font-semibold text-[0.9em] leading-[1.8]"
                    >
                      <img
                        src={Images.file}
                        className="h-[24px] w-[24px] mr-3"
                      />
                      Font Awesome (Fonticons, Inc. )
                    </AccordionSummary>
                    <AccordionDetails className="text-[0.9em] leading-[1.8] space-y-2">
                      <div>
                        Font Awesome is a typeface visualisation service
                        provided by Fonticons, Inc. that allows this Application
                        to incorporate content of this kind on its pages.
                      </div>
                      <div>
                        Personal Data processed: Trackers and Usage Data.
                      </div>
                      <div>
                        Place of processing: United States – Privacy Policy.
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Accordion disableGutters>
                    <AccordionSummary
                      expandIcon={<ArrowLeft />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="font-semibold text-[0.9em] leading-[1.8]"
                    >
                      <img
                        src={Images.file}
                        className="h-[24px] w-[24px] mr-3"
                      />
                      Google Fonts (Google Ireland Limited)
                    </AccordionSummary>
                    <AccordionDetails className="text-[0.9em] leading-[1.8] space-y-2">
                      <div>
                        Google Fonts is a typeface visualisation service
                        provided by Google Ireland Limited that allows this
                        Application to incorporate content of this kind on its
                        pages.
                      </div>
                      <div>
                        Personal Data processed: Trackers and Usage Data.
                      </div>
                      <div>Place of processing: Ireland – Privacy Policy.</div>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              </Grid>
            </div>
          </div>

          <div className="space-y-3 py-2">
            <div className="text-lg font-semibold space-y-2">
              <div>
                How to manage preferences and provide or withdraw consent on
                this Application
              </div>
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              Whenever the use of Trackers is based on consent, users can
              provide or withdraw such consent by setting or updating their
              preferences via the relevant privacy choices panel available on
              this Application.
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              With regard to any third-party Trackers, Users can manage their
              preferences via the related opt-out link (where provided), by
              using the means indicated in the third party's privacy policy, or
              by contacting the third party.
            </div>
            <div className="text-[0.9em] leading-[1.8] font-semibold">
              How to control or delete Cookies and similar technologies via your
              device settings
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              Users may use their own browser settings to:
            </div>
            <ul className="text-[0.9em] leading-[1.8] list-disc  pl-5 space-y-1">
              <li>
                See what Cookies or other similar technologies have been set on
                the device;
              </li>
              <li>Block Cookies or similar technologies;</li>
              <li>Clear Cookies or similar technologies from the browser.</li>
            </ul>
            <div className="text-[0.9em] leading-[1.8]">
              The browser settings, however, do not allow granular control of
              consent by category.
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              Users can, for example, find information about how to manage
              Cookies in the most commonly used browsers at the following
              addresses:
            </div>
            <ul className="text-[0.9em] leading-[1.8] list-disc pl-5 space-y-1">
              <li>
                <a
                  className="border-b"
                  href="https://support.google.com/chrome/answer/95647?hl=en&p=cpn_cookies"
                  target="_blank"
                >
                  Google Chrome
                </a>
              </li>
              <li>
                <a
                  className="border-b"
                  href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                  target="_blank"
                >
                  Mozilla Firefox
                </a>
              </li>
              <li>
                <a
                  className="border-b"
                  href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/"
                  target="_blank"
                >
                  Apple Safari
                </a>
              </li>
              <li>
                <a
                  className="border-b"
                  href="http://windows.microsoft.com/en-us/windows-vista/block-or-allow-cookies"
                  target="_blank"
                >
                  Microsoft Internet Explorer
                </a>
              </li>
              <li>
                <a
                  className="border-b"
                  href="https://support.microsoft.com/en-us/help/4027947"
                  target="_blank"
                >
                  Microsoft Edge
                </a>
              </li>
              <li>
                <a
                  className="border-b"
                  href="https://support.brave.com/hc/en-us/articles/360022806212-How-do-I-use-Shields-while-browsing"
                  target="_blank"
                >
                  Brave
                </a>
              </li>
              <li>
                <a
                  className="border-b"
                  href="https://help.opera.com/en/latest/web-preferences/#cookies"
                  target="_blank"
                >
                  Opera
                </a>
              </li>
            </ul>
            <div className="text-[0.9em] leading-[1.8]">
              Users may also manage certain categories of Trackers used on
              mobile apps by opting out through relevant device settings such as
              the device advertising settings for mobile devices, or tracking
              settings in general (Users may open the device settings and look
              for the relevant setting).
            </div>
            <div className="text-[0.9em] leading-[1.8] font-semibold">
              Consequences of denying consent
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              Users are free to decide whether or not to grant consent. However,
              please note that Trackers help this Application to provide a
              better experience and advanced functionalities to Users (in line
              with the purposes outlined in this document). Therefore, in the
              absence of the User's consent, the Owner may be unable to provide
              related features.
            </div>
          </div>

          <div className="border-b-[#00000013] space-y-3 py-2">
            <div className="text-xl font-semibold space-y-2">
              <div>Owner and Data Controller</div>
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              Global eSourcing ApS
              <br />
              Stensballegaardvej 23, 8700 Horsens
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              Tlf.: +45 28 40 87 00
              <br />
              CVR: 37252867
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              <Link
                className="font-semibold hover:text-[var(--blue)]"
                to={routesName.contact}
                onClick={() => {
                  onClose();
                }}
              >
                Message us
              </Link>
              {/*  <span className="font-semibold">Owner contact email</span>:
              info@aid-link.com */}
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              Since the use of third-party Trackers through this Application
              cannot be fully controlled by the Owner, any specific references
              to third-party Trackers are to be considered indicative. In order
              to obtain complete information, Users are kindly requested to
              consult the privacy policies of the respective third-party
              services listed in this document.
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              Given the objective complexity surrounding tracking technologies,
              Users are encouraged to contact the Owner should they wish to
              receive any further information on the use of such technologies by
              this Application.
            </div>
          </div>

          <div className="space-y-3 py-2">
            <Accordion disableGutters>
              <AccordionSummary
                expandIcon={<ArrowLeft />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="font-semibold text-[0.9em] leading-[1.8]"
              >
                <img src={Images.file} className="h-[24px] w-[24px] mr-3" />
                Definitions and legal references
              </AccordionSummary>
              <AccordionDetails className="text-[0.9em] leading-[1.8] space-y-3">
                <div className="">
                  <div className="font-semibold">Personal Data (or Data)</div>
                  <div>
                    Any information that directly, indirectly, or in connection
                    with other information — including a personal identification
                    number — allows for the identification or identifiability of
                    a natural person.
                  </div>
                </div>

                <div className="">
                  <div className="font-semibold">Usage Data</div>
                  <div>
                    Information collected automatically through this Application
                    (or third-party services employed in this Application),
                    which can include: the IP addresses or domain names of the
                    computers utilised by the Users who use this Application,
                    the URI addresses (Uniform Resource Identifier), the time of
                    the request, the method utilised to submit the request to
                    the server, the size of the file received in response, the
                    numerical code indicating the status of the server's answer
                    (successful outcome, error, etc.), the country of origin,
                    the features of the browser and the operating system
                    utilised by the User, the various time details per visit
                    (e.g., the time spent on each page within the Application)
                    and the details about the path followed within the
                    Application with special reference to the sequence of pages
                    visited, and other parameters about the device operating
                    system and/or the User's IT environment.
                  </div>
                </div>

                <div className="">
                  <div className="font-semibold">User</div>
                  <div>
                    The individual using this Application who, unless otherwise
                    specified, coincides with the Data Subject.
                  </div>
                </div>

                <div className="">
                  <div className="font-semibold">Data Subject</div>
                  <div>
                    The natural person to whom the Personal Data refers.
                  </div>
                </div>

                <div className="">
                  <div className="font-semibold">
                    Data Processor (or Processor)
                  </div>
                  <div>
                    The natural or legal person, public authority, agency or
                    other body which processes Personal Data on behalf of the
                    Controller, as described in this privacy policy.
                  </div>
                </div>

                <div className="">
                  <div className="font-semibold">
                    Data Controller (or Owner)
                  </div>
                  <div>
                    The natural or legal person, public authority, agency or
                    other body which, alone or jointly with others, determines
                    the purposes and means of the processing of Personal Data,
                    including the security measures concerning the operation and
                    use of this Application. The Data Controller, unless
                    otherwise specified, is the Owner of this Application.
                  </div>
                </div>

                <div className="">
                  <div className="font-semibold">This Application</div>
                  <div>
                    The means by which the Personal Data of the User is
                    collected and processed.
                  </div>
                </div>

                <div className="">
                  <div className="font-semibold">Service</div>
                  <div>
                    The service provided by this Application as described in the
                    relative terms (if available) and on this site/application.
                  </div>
                </div>

                <div className="">
                  <div className="font-semibold">European Union (or EU)</div>
                  <div>
                    Unless otherwise specified, all references made within this
                    document to the European Union include all current member
                    states to the European Union and the European Economic Area.
                  </div>
                </div>

                <div className="">
                  <div className="font-semibold">Cookie</div>
                  <div>
                    Cookies are Trackers consisting of small sets of data stored
                    in the User's browser.
                  </div>
                </div>

                <div className="">
                  <div className="font-semibold">Tracker</div>
                  <div>
                    Tracker indicates any technology - e.g Cookies, unique
                    identifiers, web beacons, embedded scripts, e-tags and
                    fingerprinting - that enables the tracking of Users, for
                    example by accessing or storing information on the User’s
                    device.
                  </div>
                </div>

                <div className="">
                  <div className="font-semibold">Legal information</div>
                  <div>
                    This privacy policy relates solely to this Application, if
                    not stated otherwise within this document.
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>

          <div className="text-[0.9em] leading-[1.8] space-y-3 pb-4">
            <div>Latest update: 12 August 2024</div>
            <div>
              iubenda hosts this content and only collects the Personal Data
              strictly necessary for it to be provided.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PrivacyPolicy = ({ onClose = () => {} }) => {
  return (
    <div className="">
      <div className="px-8 py-5 space-y-4">
        <div className="space-y-5 py-2">
          <div>
            <div className="text-lg">
              Privacy Policy of{' '}
              <span className="font-semibold">aid-link.com</span>
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              This Application collects some Personal Data from its Users.
            </div>
          </div>
          <div className="text-[0.9em] leading-[1.8]">
            This document can be printed for reference by using the print
            command in the settings of any browser.
          </div>

          <hr />
        </div>

        <div className="space-y-3">
          <div className="text-[0.9em]">
            <div className="text-lg font-semibold pt-5 mb-1">
              Owner and Data Controller
            </div>
            <div>Global eSourcing ApS</div>
            <div>Stensballegaardvej 23, 8700 Horsens</div>
          </div>
          <div className="text-[0.9em]">
            <div>Tlf.: +45 28 40 87 00</div>
            <div>CVR: 37252867</div>
          </div>
          <div className="text-[0.9em]">
            {/* <div>Owner contact email: info@aid-link.com</div> */}
            <Link
              className="font-semibold hover:text-[var(--blue)]"
              to={routesName.contact}
              onClick={() => {
                onClose();
              }}
            >
              Message us
            </Link>
          </div>
        </div>

        <hr />

        <div className="space-y-4 py-3 ">
          <div className="space-y-3 py-1 ">
            <div className="text-lg font-semibold">Types of Data collected</div>
            <div className="text-[0.9em] leading-[1.8]">
              Among the types of Personal Data that this Application collects,
              by itself or through third parties, there are: email address;
              various types of Data; Usage Data; first name; last name; Data
              communicated while using the service; Trackers; phone number.
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              Complete details on each type of Personal Data collected are
              provided in the dedicated sections of this privacy policy or by
              specific explanation texts displayed prior to the Data collection.
              Personal Data may be freely provided by the User, or, in case of
              Usage Data, collected automatically when using this Application.
              <br />
              Unless specified otherwise, all Data requested by this Application
              is mandatory and failure to provide this Data may make it
              impossible for this Application to provide its services. In cases
              where this Application specifically states that some Data is not
              mandatory, Users are free not to communicate this Data without
              consequences to the availability or the functioning of the
              Service.
              <br />
              Users who are uncertain about which Personal Data is mandatory are
              welcome to contact the Owner. Any use of Cookies – or of other
              tracking tools — by this Application or by the owners of
              third-party services used by this Application serves the purpose
              of providing the Service required by the User, in addition to any
              other purposes described in the present document and in the Cookie
              Policy.
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              Users are responsible for any third-party Personal Data obtained,
              published or shared through this Application.
            </div>
          </div>

          <hr />

          <div className="text-lg font-semibold ">
            Mode and place of processing the Data
          </div>

          <div className="space-y-4 py-2">
            <div className="space-y-1">
              <div className="text-md font-semibold ">
                Methods of processing
              </div>

              <div className="text-[0.9em] leading-[1.8]">
                The Owner takes appropriate security measures to prevent
                unauthorised access, disclosure, modification, or unauthorised
                destruction of the Data. The Data processing is carried out
                using computers and/or IT enabled tools, following
                organisational procedures and modes strictly related to the
                purposes indicated. In addition to the Owner, in some cases, the
                Data may be accessible to certain types of persons in charge,
                involved with the operation of this Application (administration,
                sales, marketing, legal, system administration) or external
                parties (such as third-party technical service providers, mail
                carriers, hosting providers, IT companies, communications
                agencies) appointed, if necessary, as Data Processors by the
                Owner. The updated list of these parties may be requested from
                the Owner at any time.
              </div>
            </div>

            <div className="space-y-1">
              <div className="text-md font-semibold ">Place</div>

              <div className="text-[0.9em] leading-[1.8]">
                The Data is processed at the Owner's operating offices and in
                any other places where the parties involved in the processing
                are located.
              </div>
            </div>
            <div className="text-[0.9em] leading-[1.8]">
              Depending on the User's location, data transfers may involve
              transferring the User's Data to a country other than their own. To
              find out more about the place of processing of such transferred
              Data, Users can check the section containing details about the
              processing of Personal Data.
            </div>

            <div className="space-y-1">
              <div className="text-md font-semibold ">Retention time</div>

              <div className="text-[0.9em] leading-[1.8]">
                Personal Data shall be processed and stored for as long as
                required by the purpose they have been collected for.
              </div>
            </div>

            <hr />
            <div className="space-y-1">
              <div className="text-lg font-semibold ">
                The purposes of processing
              </div>

              <div className="text-[0.9em] leading-[1.8]">
                The Data concerning the User is collected to allow the Owner to
                provide its Service, comply with its legal obligations, respond
                to enforcement requests, protect its rights and interests (or
                those of its Users or third parties), detect any malicious or
                fraudulent activity, as well as the following: Managing contacts
                and sending messages, Building and running this Application,
                Displaying content from external platforms and Managing data
                collection and online surveys.
              </div>

              <div className="text-[0.9em] leading-[1.8] pt-2">
                For specific information about the Personal Data used for each
                purpose, the User may refer to the section “Detailed information
                on the processing of Personal Data”.
              </div>
            </div>

            <hr />

            <div className="space-y-1">
              <div className="text-lg font-semibold ">
                Detailed information on the processing of Personal Data
              </div>

              <div className="text-[0.9em] leading-[1.8]">
                Personal Data is collected for the following purposes and using
                the following services: surveys.
              </div>

              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <Accordion disableGutters>
                    <AccordionSummary
                      expandIcon={<ArrowLeft />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="font-semibold text-[0.9em] leading-[1.8]"
                    >
                      <img
                        src={Images.file}
                        className="h-[24px] w-[24px] mr-3"
                      />
                      Building and running this Application
                    </AccordionSummary>
                    <AccordionDetails className="text-[0.9em] leading-[1.8] space-y-2">
                      <div>
                        Key components of this Application are built and run
                        directly by the Owner by making use of the software
                        listed below.
                      </div>
                      <div className="font-semi-bold">
                        WordPress (self-hosted) (this Application)
                      </div>
                      <div>
                        This Application is built and run by the Owner via a CMS
                        software (Content Management System) called WordPress.
                      </div>
                      <div>
                        Personal Data processed: Data communicated while using
                        the service.
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Accordion disableGutters>
                    <AccordionSummary
                      expandIcon={<ArrowLeft />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="font-semibold text-[0.9em] leading-[1.8]"
                    >
                      <img
                        src={Images.file}
                        className="h-[24px] w-[24px] mr-3"
                      />
                      Displaying content from external platforms
                    </AccordionSummary>
                    <AccordionDetails className="text-[0.9em] leading-[1.8] space-y-2">
                      <div>
                        This type of service allows you to view content hosted
                        on external platforms directly from the pages of this
                        Application and interact with them. Such services are
                        often referred to as widgets, which are small elements
                        placed on a website or app. They provide specific
                        information or perform a particular function and often
                        allow for user interaction. This type of service might
                        still collect web traffic data for the pages where the
                        service is installed, even when Users do not use it.
                      </div>
                      <div className="font-semi-bold">
                        Google Maps widget (Google Ireland Limited)
                      </div>
                      <div>
                        Google Maps is a maps visualisation service provided by
                        Google Ireland Limited that allows this Application to
                        incorporate content of this kind on its pages.
                      </div>
                      <div>Personal Data processed: Trackers; Usage Data.</div>
                      <div>Place of processing: Ireland – Privacy Policy.</div>
                      <div className="font-semibold">
                        Font Awesome (Fonticons, Inc. )
                      </div>
                      <div>
                        Font Awesome is a typeface visualisation service
                        provided by Fonticons, Inc. that allows this Application
                        to incorporate content of this kind on its pages.
                      </div>
                      <div>Personal Data processed: Trackers; Usage Data.</div>
                      <div>
                        Place of processing: United States – Privacy Policy.
                      </div>
                      <div className="font-semibold">
                        Google Fonts (Google Ireland Limited)
                      </div>
                      <div>
                        Google Fonts is a typeface visualisation service
                        provided by Google Ireland Limited that allows this
                        Application to incorporate content of this kind on its
                        pages.
                      </div>
                      <div>Personal Data processed: Trackers; Usage Data.</div>
                      <div>Place of processing: Ireland – Privacy Policy.</div>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Accordion disableGutters>
                    <AccordionSummary
                      expandIcon={<ArrowLeft />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="font-semibold text-[0.9em] leading-[1.8]"
                    >
                      <img
                        src={Images.file}
                        className="h-[24px] w-[24px] mr-3"
                      />
                      Managing contacts and sending messages
                    </AccordionSummary>
                    <AccordionDetails className="text-[0.9em] leading-[1.8] space-y-2">
                      <div>
                        This type of service makes it possible to manage a
                        database of email contacts, phone contacts or any other
                        contact information to communicate with the User. These
                        services may also collect data concerning the date and
                        time when the message was viewed by the User, as well as
                        when the User interacted with it, such as by clicking on
                        links included in the message.
                      </div>
                      <div className="font-semibold">
                        Mailgun (Mailgun Technologies, Inc.)
                      </div>
                      <div>
                        Mailgun is an email address management and message
                        sending service provided by Mailgun Technologies, Inc.
                      </div>
                      <div>
                        Personal Data processed: email address; first name; last
                        name; Usage Data; various types of Data.
                      </div>
                      <div>Place of processing: Germany – Privacy Policy.</div>
                    </AccordionDetails>
                  </Accordion>
                </Grid>{' '}
                <Grid item md={6} xs={12}>
                  <Accordion disableGutters>
                    <AccordionSummary
                      expandIcon={<ArrowLeft />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="font-semibold text-[0.9em] leading-[1.8]"
                    >
                      <img
                        src={Images.file}
                        className="h-[24px] w-[24px] mr-3"
                      />
                      Managing data collection and online surveys
                    </AccordionSummary>
                    <AccordionDetails className="text-[0.9em] leading-[1.8] space-y-2">
                      <div>
                        This type of service allows this Application to manage
                        the creation, deployment, administration, distribution
                        and analysis of online forms and surveys in order to
                        collect, save and reuse Data from any responding Users.
                        The Personal Data collected depend on the information
                        asked and provided by the Users in the corresponding
                        online form.
                      </div>
                      <div>
                        These services may be integrated with a wide range of
                        third-party services to enable the Owner to take
                        subsequent steps with the Data processed - e.g. managing
                        contacts, sending messages, analytics, advertising and
                        payment processing.
                      </div>
                      <div className="font-semibold">
                        Elementor Form widget (Elementor Ltd.)
                      </div>
                      <div>
                        Elementor Form widget is a form builder for Elementor.
                      </div>
                      <div>
                        Personal Data processed: Data communicated while using
                        the service; email address; first name; last name; phone
                        number; Usage Data.
                      </div>
                      <div>Place of processing: Israel – Privacy Policy.</div>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              </Grid>
            </div>

            <hr />

            <div className="space-y-1">
              <div className="text-lg font-semibold ">
                Further information about the processing of Personal Data
              </div>

              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <Accordion disableGutters>
                    <AccordionSummary
                      expandIcon={<ArrowLeft />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      className="font-semibold text-[0.9em] leading-[1.8]"
                    >
                      <img
                        src={Images.file}
                        className="h-[24px] w-[24px] mr-3"
                      />
                      Selling goods and services online
                    </AccordionSummary>
                    <AccordionDetails className="text-[0.9em] leading-[1.8] space-y-2">
                      <div>
                        The Personal Data collected are used to provide the User
                        with services or to sell goods, including payment and
                        possible delivery. The Personal Data collected to
                        complete the payment may include the credit card, the
                        bank account used for the transfer, or any other means
                        of payment envisaged. The kind of Data collected by this
                        Application depends on the payment system used.
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              </Grid>
            </div>

            <hr />
            <div className="space-y-1">
              <div className="text-lg font-semibold ">Cookie Policy</div>

              <div className="text-[0.9em] leading-[1.8]">
                This Application uses Trackers. To learn more, Users may consult
                the Cookie Policy.
              </div>
            </div>

            <hr />

            <div className="text-lg font-semibold space-y-2">
              Further Information for Users
            </div>

            <div className="space-y-3 py-2">
              <div className="space-y-1">
                <div className="text-md font-semibold space-y-2">
                  Legal basis of processing
                </div>

                <div className="text-[0.9em] leading-[1.8]">
                  The Owner may process Personal Data relating to Users if one
                  of the following applies:
                </div>

                <ul className="text-[0.9em] leading-[1.8] list-disc  pl-7 space-y-1">
                  <li>
                    Users have given their consent for one or more specific
                    purposes.
                  </li>
                  <li>
                    provision of Data is necessary for the performance of an
                    agreement with the User and/or for any pre-contractual
                    obligations thereof;
                  </li>
                  <li>
                    processing is necessary for compliance with a legal
                    obligation to which the Owner is subject;
                  </li>
                  <li>
                    processing is related to a task that is carried out in the
                    public interest or in the exercise of official authority
                    vested in the Owner;
                  </li>
                  <li>
                    processing is necessary for the purposes of the legitimate
                    interests pursued by the Owner or by a third party.
                  </li>
                </ul>

                <div className="text-[0.9em] leading-[1.8]">
                  In any case, the Owner will gladly help to clarify the
                  specific legal basis that applies to the processing, and in
                  particular whether the provision of Personal Data is a
                  statutory or contractual requirement, or a requirement
                  necessary to enter into a contract.
                </div>
              </div>

              <div className="space-y-1">
                <div className="text-md font-semibold space-y-2">
                  Further information about retention time
                </div>

                <div className="text-[0.9em] leading-[1.8]">
                  Personal Data shall be processed and stored for as long as
                  required by the purpose they have been collected for.
                </div>

                <div className="text-[0.9em] leading-[1.8]">Therefore:</div>

                <ul className="text-[0.9em] leading-[1.8] list-disc  pl-7 space-y-1">
                  <li>
                    Personal Data collected for purposes related to the
                    performance of a contract between the Owner and the User
                    shall be retained until such contract has been fully
                    performed.
                  </li>
                  <li>
                    Personal Data collected for the purposes of the Owner’s
                    legitimate interests shall be retained as long as needed to
                    fulfill such purposes. Users may find specific information
                    regarding the legitimate interests pursued by the Owner
                    within the relevant sections of this document or by
                    contacting the Owner.
                  </li>
                </ul>

                <div className="text-[0.9em] leading-[1.8]">
                  The Owner may be allowed to retain Personal Data for a longer
                  period whenever the User has given consent to such processing,
                  as long as such consent is not withdrawn. Furthermore, the
                  Owner may be obliged to retain Personal Data for a longer
                  period whenever required to fulfil a legal obligation or upon
                  order of an authority.
                </div>
                <div className="text-[0.9em] leading-[1.8]">
                  Once the retention period expires, Personal Data shall be
                  deleted. Therefore, the right of access, the right to erasure,
                  the right to rectification and the right to data portability
                  cannot be enforced after expiration of the retention period.
                </div>
              </div>

              <div className="space-y-1">
                <div className="text-md font-semibold space-y-2">
                  The rights of Users based on the General Data Protection
                  Regulation (GDPR)
                </div>

                <div className="text-[0.9em] leading-[1.8]">
                  Users may exercise certain rights regarding their Data
                  processed by the Owner.
                </div>

                <div className="text-[0.9em] leading-[1.8]">
                  In particular, Users have the right to do the following, to
                  the extent permitted by law:
                </div>

                <ul className="text-[0.9em] leading-[1.8] list-disc  pl-7 space-y-1">
                  <li>
                    <span className="font-semibold">
                      Withdraw their consent at any time.
                    </span>{' '}
                    <span>
                      Users have the right to withdraw consent where they have
                      previously given their consent to the processing of their
                      Personal Data.
                    </span>
                  </li>
                  <li>
                    <span className="font-semibold">
                      Object to processing of their Data.
                    </span>{' '}
                    <span>
                      Users have the right to object to the processing of their
                      Data if the processing is carried out on a legal basis
                      other than consent.
                    </span>
                  </li>
                  <li>
                    <span className="font-semibold">Access their Data.</span>{' '}
                    <span>
                      Users have the right to learn if Data is being processed
                      by the Owner, obtain disclosure regarding certain aspects
                      of the processing and obtain a copy of the Data undergoing
                      processing.
                    </span>
                  </li>
                  <li>
                    <span className="font-semibold">
                      Verify and seek rectification.
                    </span>{' '}
                    <span>
                      Users have the right to verify the accuracy of their Data
                      and ask for it to be updated or corrected.
                    </span>
                  </li>
                  <li>
                    <span className="font-semibold">
                      Restrict the processing of their Data.
                    </span>{' '}
                    <span>
                      Users have the right to restrict the processing of their
                      Data. In this case, the Owner will not process their Data
                      for any purpose other than storing it.
                    </span>
                  </li>
                  <li>
                    <span className="font-semibold">
                      Have their Personal Data deleted or otherwise removed.
                    </span>{' '}
                    <span>
                      Users have the right to obtain the erasure of their Data
                      from the Owner.
                    </span>
                  </li>
                  <li>
                    <span className="font-semibold">
                      Receive their Data and have it transferred to another
                      controller.
                    </span>{' '}
                    <span>
                      Users have the right to receive their Data in a
                      structured, commonly used and machine readable format and,
                      if technically feasible, to have it transmitted to another
                      controller without any hindrance.
                    </span>
                  </li>
                  <li>
                    <span className="font-semibold">Lodge a complaint. </span>{' '}
                    <span>
                      {' '}
                      Users have the right to bring a claim before their
                      competent data protection authority.
                    </span>
                  </li>
                </ul>

                <div className="text-[0.9em] leading-[1.8]">
                  Users are also entitled to learn about the legal basis of Data
                  transfers to a country outside the European Union or to any
                  international organisation governed by public international
                  law or set up by two or more countries, such as the UN, and
                  about the security measures taken by the Owner to safeguard
                  their Data.
                </div>
                <div className="text-[0.9em] leading-[1.8]">
                  If any such transfer takes place, Users can find out more by
                  checking the relevant sections of this document or enquire
                  with the Owner using the information provided in the contact
                  section.
                </div>
                <div className="text-[0.9em] leading-[1.8] font-semi-bold">
                  Where Personal Data is processed for a public interest, in the
                  exercise of an official authority vested in the Owner or for
                  the purposes of the legitimate interests pursued by the Owner,
                  Users may object to such processing by providing a ground
                  related to their particular situation to justify the
                  objection.
                </div>
                <div className="text-[0.9em] leading-[1.8] font-semi-bold">
                  Users must know that, however, should their Personal Data be
                  processed for direct marketing purposes, they can object to
                  that processing at any time, free of charge and without
                  providing any justification. Where the User objects to
                  processing for direct marketing purposes, the Personal Data
                  will no longer be processed for such purposes. To learn
                  whether the Owner is processing Personal Data for direct
                  marketing purposes, Users may refer to the relevant sections
                  of this document.
                </div>
                <div className="text-[0.9em] leading-[1.8] font-semibold">
                  How to exercise these rights
                </div>
                <div className="text-[0.9em] leading-[1.8]">
                  Any requests to exercise User rights can be directed to the
                  Owner through the contact details provided in this document.
                  Such requests are free of charge and will be answered by the
                  Owner as early as possible and always within one month,
                  providing Users with the information required by law. Any
                  rectification or erasure of Personal Data or restriction of
                  processing will be communicated by the Owner to each
                  recipient, if any, to whom the Personal Data has been
                  disclosed unless this proves impossible or involves
                  disproportionate effort. At the Users’ request, the Owner will
                  inform them about those recipients.
                </div>
              </div>
            </div>

            <hr />

            <div className="text-lg font-semibold ">
              Additional information about Data collection and processing
            </div>

            <div className="space-y-1">
              <div className="text-sm font-semibold ">Legal action</div>

              <div className="text-[0.9em] leading-[1.8]">
                The User's Personal Data may be used for legal purposes by the
                Owner in Court or in the stages leading to possible legal action
                arising from improper use of this Application or the related
                Services.
                <br />
                The User declares to be aware that the Owner may be required to
                reveal personal data upon request of public authorities.
              </div>
            </div>

            <div className="space-y-1">
              <div className="text-sm font-semibold ">
                Additional information about User's Personal Data
              </div>

              <div className="text-[0.9em] leading-[1.8]">
                In addition to the information contained in this privacy policy,
                this Application may provide the User with additional and
                contextual information concerning particular Services or the
                collection and processing of Personal Data upon request.
              </div>
            </div>

            <div className="space-y-1">
              <div className="text-sm font-semibold ">
                System logs and maintenance
              </div>
              <div className="text-[0.9em] leading-[1.8]">
                For operation and maintenance purposes, this Application and any
                third-party services may collect files that record interaction
                with this Application (System logs) or use other Personal Data
                (such as the IP Address) for this purpose.
              </div>
            </div>
            <div className="space-y-1">
              <div className="text-sm font-semibold ">
                Information not contained in this policy
              </div>
              <div className="text-[0.9em] leading-[1.8]">
                More details concerning the collection or processing of Personal
                Data may be requested from the Owner at any time. Please see the
                contact information at the beginning of this document.
              </div>
            </div>
            <div className="space-y-1">
              <div className="text-sm font-semibold ">
                Changes to this privacy policy
              </div>
              <div className="text-[0.9em] leading-[1.8]">
                The Owner reserves the right to make changes to this privacy
                policy at any time by notifying its Users on this page and
                possibly within this Application and/or - as far as technically
                and legally feasible - sending a notice to Users via any contact
                information available to the Owner. It is strongly recommended
                to check this page often, referring to the date of the last
                modification listed at the bottom.
              </div>
            </div>

            <div className="text-[0.9em] leading-[1.8]">
              Should the changes affect processing activities performed on the
              basis of the User’s consent, the Owner shall collect new consent
              from the User, where required.
            </div>

            <hr />
            <div className="space-y-3 py-2">
              <Accordion disableGutters>
                <AccordionSummary
                  expandIcon={<ArrowLeft />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="font-semibold text-[0.9em] leading-[1.8]"
                >
                  <img src={Images.file} className="h-[24px] w-[24px] mr-3" />
                  Definitions and legal references
                </AccordionSummary>
                <AccordionDetails className="text-[0.9em] leading-[1.8] space-y-3">
                  <div className="">
                    <div className="font-semibold">Personal Data (or Data)</div>
                    <div>
                      Any information that directly, indirectly, or in
                      connection with other information — including a personal
                      identification number — allows for the identification or
                      identifiability of a natural person.
                    </div>
                  </div>

                  <div className="">
                    <div className="font-semibold">Usage Data</div>
                    <div>
                      Information collected automatically through this
                      Application (or third-party services employed in this
                      Application), which can include: the IP addresses or
                      domain names of the computers utilised by the Users who
                      use this Application, the URI addresses (Uniform Resource
                      Identifier), the time of the request, the method utilised
                      to submit the request to the server, the size of the file
                      received in response, the numerical code indicating the
                      status of the server's answer (successful outcome, error,
                      etc.), the country of origin, the features of the browser
                      and the operating system utilised by the User, the various
                      time details per visit (e.g., the time spent on each page
                      within the Application) and the details about the path
                      followed within the Application with special reference to
                      the sequence of pages visited, and other parameters about
                      the device operating system and/or the User's IT
                      environment.
                    </div>
                  </div>

                  <div className="">
                    <div className="font-semibold">User</div>
                    <div>
                      The individual using this Application who, unless
                      otherwise specified, coincides with the Data Subject.
                    </div>
                  </div>

                  <div className="">
                    <div className="font-semibold">Data Subject</div>
                    <div>
                      The natural person to whom the Personal Data refers.
                    </div>
                  </div>

                  <div className="">
                    <div className="font-semibold">
                      Data Processor (or Processor)
                    </div>
                    <div>
                      The natural or legal person, public authority, agency or
                      other body which processes Personal Data on behalf of the
                      Controller, as described in this privacy policy.
                    </div>
                  </div>

                  <div className="">
                    <div className="font-semibold">
                      Data Controller (or Owner)
                    </div>
                    <div>
                      The natural or legal person, public authority, agency or
                      other body which, alone or jointly with others, determines
                      the purposes and means of the processing of Personal Data,
                      including the security measures concerning the operation
                      and use of this Application. The Data Controller, unless
                      otherwise specified, is the Owner of this Application.
                    </div>
                  </div>

                  <div className="">
                    <div className="font-semibold">This Application</div>
                    <div>
                      The means by which the Personal Data of the User is
                      collected and processed.
                    </div>
                  </div>

                  <div className="">
                    <div className="font-semibold">Service</div>
                    <div>
                      The service provided by this Application as described in
                      the relative terms (if available) and on this
                      site/application.
                    </div>
                  </div>

                  <div className="">
                    <div className="font-semibold">European Union (or EU)</div>
                    <div>
                      Unless otherwise specified, all references made within
                      this document to the European Union include all current
                      member states to the European Union and the European
                      Economic Area.
                    </div>
                  </div>

                  <div className="">
                    <div className="font-semibold">Cookie</div>
                    <div>
                      Cookies are Trackers consisting of small sets of data
                      stored in the User's browser.
                    </div>
                  </div>

                  <div className="">
                    <div className="font-semibold">Tracker</div>
                    <div>
                      Tracker indicates any technology - e.g Cookies, unique
                      identifiers, web beacons, embedded scripts, e-tags and
                      fingerprinting - that enables the tracking of Users, for
                      example by accessing or storing information on the User’s
                      device.
                    </div>
                  </div>

                  <div className="">
                    <div className="font-semibold">Legal information</div>
                    <div>
                      This privacy policy relates solely to this Application, if
                      not stated otherwise within this document.
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
            <hr />
          </div>

          <div className="text-[0.9em] leading-[1.8] space-y-3 pb-4">
            <div>Latest update: 12 August 2024</div>
            <div>
              iubenda hosts this content and only collects the Personal Data
              strictly necessary for it to be provided.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
